export default "__VITE_ASSET__BNhrLX9m__"